import { useState as c, useEffect as s } from "react";
const m = (t) => {
  const [n, r] = c(t != null && t.current ? t.current.getBoundingClientRect() : {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }), [l, i] = c(t != null && t.current ? {
    bottom: t.current.scrollTop,
    maxBottom: t.current.scrollTop - t.current.getBoundingClientRect().height,
    scrollHeight: t.current.scrollHeight
  } : {
    bottom: 0,
    maxBottom: 0,
    scrollHeight: 0
  });
  return s(() => {
    if (!(t != null && t.current))
      return;
    const o = new ResizeObserver(() => {
      const e = t.current.getBoundingClientRect();
      (e.width !== n.width || e.height !== n.height) && r(e);
    });
    return o.observe(t.current), () => {
      o.disconnect();
    };
  }, [n.height, n.width, t]), s(() => {
    if (!t.current)
      return;
    const o = t.current, e = () => {
      const u = o.getBoundingClientRect(), h = {
        bottom: o.scrollTop,
        maxBottom: o.scrollHeight - u.height,
        scrollHeight: o.scrollHeight
      };
      i(h);
    };
    return o.addEventListener("scroll", e), () => o.removeEventListener("scroll", e);
  }, [n, t]), { pos: n, scrollPos: l };
};
export {
  m as useElementPos
};
